import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'

export class FileFormats extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new FileFormats())

  @alias('thumbnail')
  thumbnail!: string | null
  @alias('preview')
  preview!: string | null
  @alias('analysis')
  analysis!: string | null

  constructor() {
    super((FileFormats as unknown as AliasedConstructor)._alias)
  }
}
